export interface IGetTopicsContentTypesResponse {
  totalCount: number;
  type: string;
  unreadCount: number;
}

export interface IGetTopicsItem {
  htmlDescription: string;
  id: number;
  isRead: boolean;
  publishDate: string;
  sourceUrl: string;
  summary: string;
  title: string;
  type: string;
}

export interface IGetTopicsItemsResponse {
  isEmpty: boolean;
  items: IGetTopicsItem[];
  itemsCount: number;
  skipToken: number;
  totalCount: number;
}

export interface IMyTopicsTypes {
  name: string;
  typeName: string;
  totalCount: number;
  unreadCount: number;
}

export const MY_TOPIC_TYPES: IMyTopicsTypes[] = [
  {
    name: 'All topics',
    typeName: 'All',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'News',
    typeName: 'News',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Publications',
    typeName: 'Publication',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Meetings',
    typeName: 'Meeting',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Standards',
    typeName: 'Standard',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Projects',
    typeName: 'Project',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Jurisdictions',
    typeName: 'Jurisdiction',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Resources',
    typeName: 'Resource',
    totalCount: 0,
    unreadCount: 0,
  },
  {
    name: 'Important dates',
    typeName: 'ImportantDates',
    totalCount: 0,
    unreadCount: 0,
  },

];

export type TopicTypes =
  'All'
  | 'News'
  | 'Publication'
  | 'Meeting'
  | 'Standard'
  | 'Project'
  | 'Jurisdiction'
  | 'Resource'
  | 'ImportantDates';

export const TypesAPIMapObj = {
  All: 'all',
  News: 'news',
  Publication: 'publications',
  Meeting: 'meetings',
  Standard: 'standards',
  Project: 'projects',
  Jurisdiction: 'jurisdictions',
  Resource: 'resources',
  ImportantDates: 'important-dates',
};
